import { NormalContentLayout } from "common/components/layouts/NormalContentLayout";
import { SimpleTabs } from "common/components/tabs/SimpleTabs";
import * as React from "react";
import { AnsweredQuestions } from "../questions/AnsweredQuestions";
import { AskQuestion } from "../questions/AskQuestion";
import { UnAnsweredQuestions } from "../questions/UnAnsweredQuestions";
import { feedbackBreadcrumb } from "domain/pages/breadcrumbs";

export const QuestionsPage: React.FC = () => {
  return (
    <NormalContentLayout
      title="Mine spørsmål"
      breadcrumbItems={feedbackBreadcrumb}
    >
      <SimpleTabs
        content={[
          {
            title: "Still spørsmål",
            content: <AskQuestion />,
          },
          {
            title: "Besvarte",
            content: <AnsweredQuestions />,
          },
          {
            title: "Ubesvarte",
            content: <UnAnsweredQuestions />,
          },
        ]}
      />
    </NormalContentLayout>
  );
};
